/* eslint-disable camelcase */
import { BonusTicketType } from '@core/models/bonus/BonusConditions';

export type BonusIncludedDto = {
    event_id?: IncludedDetailDto[];
    sport_id?: IncludedDetailDto[];
    cms_game_id?: IncludedDetailDto[];
    tournament_id?: IncludedDetailDto[];
    category_id?: IncludedDetailDto[];
    odds?: IncludeOdds;
    phase?: IncludedEventTypeDto;
    ticket_type?: BonusTicketType;
};

type IncludeOdds = {
    min_odds?: OddType;
    total_odds?: OddType;
};

type OddType = {
    operation: string;
    value: number;
};

export type IncludedDetailDto = {
    id: string;
    name: string;
};

export const IncludedEventTypeDto = {
    InPlay: 'ip',
    PreMatch: 'pm',
    Mixed: 'mixed',
} as const;
export type IncludedEventTypeDto = typeof IncludedEventTypeDto[keyof typeof IncludedEventTypeDto];
